const MAX_PURCHASE_ITEM_QUANTITY = 999999999.999;

const isPurchaseItemQuantityWithinLimit = (value) => {
  const quantity = Number(value);
  return Number.isFinite(quantity) && quantity >= 0 && quantity <= MAX_PURCHASE_ITEM_QUANTITY;
};

const buildPurchaseItemQuantityLimitMessage = (item) => {
  const label = item?.varietyName ? ` de ${item.varietyName}` : '';
  return `La cantidad${label} excede el maximo permitido (${MAX_PURCHASE_ITEM_QUANTITY}).`;
};

const findInvalidPurchaseItemQuantity = (items) =>
  (Array.isArray(items) ? items : []).find(
    (item) => !isPurchaseItemQuantityWithinLimit(item?.quantity)
  ) || null;

export {
  MAX_PURCHASE_ITEM_QUANTITY,
  isPurchaseItemQuantityWithinLimit,
  buildPurchaseItemQuantityLimitMessage,
  findInvalidPurchaseItemQuantity,
};
